export const langEn = {
  // Common
  fetching_data: 'Fetching data',
  reload_section: 'Reload section',
  automatic_data_fetching_disabled: 'Automatic data fetching is disabled, reload to sync.',
  warning_label: 'Warning:',
  error_label: 'Error:',
  no_board_defined: 'No data source defined.',
  no_text_defined: 'No headline or text defined.',
  no_url_defined: 'No embed URL defined.',
  section_type_missing: 'Section type is missing.',

  // Login Page
  sign_in_to_your_account: 'Sign in to your account',
  email: 'Email',
  password: 'Password',
  sign_in: 'Sign in',
  sign_out: 'Sign out',
  or: 'OR',

  // Portal Header
  activity: 'Activity',
  inbox: 'Messages',

  // Portal Footer
  copyright: 'Copyright © [YEAR] by [PORTAL_NAME]. All rights reserved.',

  // Table section
  download_file: 'Download [FILE_NAME]',
  section_empty: 'No matching results found.',
  section_no_column_visible: 'No columns are set visible at the moment.',
  aggregate_label_sum: 'Sum',
  aggregate_label_avg: 'Avg',
  aggregate_label_min: 'Min',
  aggregate_label_max: 'Max',
  aggregate_label_count: 'Count',
  aggregate_label_median: 'Med',

  // Grid Section
  show_more: 'Show more',

  // Detail View
  show_details: 'Show details',
  no_details_available: 'No details available',

  // File Viewer [Modal]
  download: 'Download',
  preview: 'Preview',
  no_preview_available: 'No preview available for',

  // Activity Log [Modal]
  activity_from: 'Activity from',
  no_recent_activity: 'No recent activity',
  activity_older_than_30_days: 'No activity in the last 30 days',

  // Account Settings [Modal]
  account_settings: 'Account Settings',
  current_password: 'Current password',
  new_password: 'New password',
  confirm_password: 'Confirm password',
  password_must_have: 'Password must have at least 8 characters, including one number and one symbol.',
  save: 'Save',
  the_account_password_was_successfully_updated: 'The account password was successfully updated. Start using it on your next sign in.',

  // Item Comments [Modal]
  comments: 'Comments',
  attachments_max_size: 'Maximum file size is 50 MB.',
  the_file_exceeds: 'The file size exceeds the 50 MB limit.',
  type_your_comment_here: 'Type your comment here...',
  type_your_reply_here: 'Type your reply here...',
  //create_comment: 'Create comment',
  create_comment: 'Create',
  comment_time_ago: '[NAME] · [DATE] ago',
  delete: 'Delete',
  replied: 'replied',
  cancel: 'Cancel',
  reply: 'Reply',
  no_comments_yet: 'No comments yet',

  // Client Inbox [Modal]
  no_messages_yet: 'No messages yet',

  // Item Editing [Modal]
  edit: 'Edit',
  upload: 'Upload',
  upload_new_file: 'Upload new file',
  uploading_file: 'Uploading file',
  new: 'New',
  file_must_be: 'File must be 50 MB or smaller',
  choose_file: 'Choose file',
  uploaded_files: 'Uploaded files',
  delete_files: 'Delete files',
  deleting_file: 'Deleting files',
  saving: 'Saving',
  column_type_not_found: 'Column type not found',
  no_value_found: 'No value found for this column.',
  column_type_not_supported: 'This column type is not supported yet.',
  choose_an_option: 'Choose an option from above then click save.',
  update_the_text: 'Update the text above then click save.',
  update_the_number: 'Update the number above then click save.',
  utc_time_info: `Enter the time in UTC. Display adjusts to the portal's time zone after saving.`,
  time: 'Time',

  // Item Search
  search_placeholder: 'Search',
  search_in: ' in',
  search_button: 'Search',
  search_clear: 'Reset',
  search_all_columns: 'All columns',
  search_no_columns: 'No searchable columns',
  search_column_placeholder: 'Choose where to search',

  // Table Sorting
  sort_ascending: 'Sort ascending',
  sort_descending: 'Sort descending',
  sort_reset: 'Reset sorting',

  // File Upload
  upload_file: 'Uploading',
  process_file: 'Processing',
  retry_file_upload: 'Retry',

  // Warnings + Errors
  could_not_load_section: 'Could not load section',
  section_setup_incomplete: 'Section setup incomplete',
  higher_error_rates: 'Error rates are higher than usual at the moment, we apologize for the inconvenience.',
  check_status: 'Check status',
  item_actions_expired: 'Your access to this item has expired. Please refresh the page to use these actions.',
};

const langDe: typeof langEn = {
  // Common
  fetching_data: 'Daten werden abgerufen',
  reload_section: 'Abschnitt neu laden',
  automatic_data_fetching_disabled: 'Automatischer Datenabgleich ist deaktiviert, zum Synchronisieren neu laden.',
  warning_label: 'Warnung:',
  error_label: 'Fehler:',
  no_board_defined: 'Keine Datenquelle definiert.',
  no_text_defined: 'Keine Überschrift oder Text definiert.',
  no_url_defined: 'Keine Einbettungs-URL definiert.',
  section_type_missing: 'Der Abschnittstyp fehlt.',

  // Login Page
  sign_in_to_your_account: 'Anmelden bei Ihrem Konto',
  email: 'E-Mail',
  password: 'Passwort',
  sign_in: 'Anmelden',
  sign_out: 'Abmelden',
  or: 'ODER',

  // Portal Header
  activity: 'Aktivität',
  inbox: 'Nachrichten',

  // Portal Footer
  copyright: 'Copyright © [YEAR] [PORTAL_NAME]. Alle Rechte vorbehalten.',

  // Table section
  download_file: 'Herunterladen [FILE_NAME]',
  section_empty: 'Derzeit gibt es hier nichts anzuzeigen.',
  section_no_column_visible: 'Derzeit sind keine Spalten auf sichtbar gestellt.',
  aggregate_label_sum: 'Summe',
  aggregate_label_avg: 'Durchschnitt',
  aggregate_label_min: 'Minimum',
  aggregate_label_max: 'Maximum',
  aggregate_label_count: 'Anzahl',
  aggregate_label_median: 'Median',

  // Grid Section
  show_more: 'Mehr anzeigen',

  // Detail View
  show_details: 'Details anzeigen',
  no_details_available: 'Keine Details verfügbar',

  // File Viewer [Modal]
  download: 'Download',
  preview: 'Vorschau',
  no_preview_available: 'Keine Vorschau verfügbar für',

  // Activity Log [Modal]
  activity_from: 'Aktivität von',
  no_recent_activity: 'Keine aktuellen Aktivitäten',
  activity_older_than_30_days: 'Keine Aktivitäten in den letzten 30 Tagen',

  // Account Settings [Modal]
  account_settings: 'Kontoeinstellungen',
  current_password: 'Aktuelles Passwort',
  new_password: 'Neues Passwort',
  confirm_password: 'Passwort bestätigen',
  password_must_have: 'Das Passwort muss mindestens 8 Zeichen, einschließlich einer Zahl und eines Symbols, enthalten.',
  save: 'Speichern',
  the_account_password_was_successfully_updated:
    'Das Kontopasswort wurde erfolgreich aktualisiert. Verwenden Sie es bei Ihrer nächsten Anmeldung.',

  // Item Comments [Modal]
  comments: 'Kommentare',
  attachments_max_size: 'Maximale Dateigröße beträgt 50 MB.',
  the_file_exceeds: 'Die Dateigröße überschreitet das 50 MB Limit.',
  type_your_comment_here: 'Geben Sie hier Ihren Kommentar ein...',
  type_your_reply_here: 'Geben Sie hier Ihre Antwort ein...',
  //create_comment: 'Kommentar erstellen',
  create_comment: 'Erstellen',
  comment_time_ago: '[NAME] · Vor [DATE]',
  delete: 'Löschen',
  replied: 'antwortete',
  cancel: 'Abbrechen',
  reply: 'Antworten',
  no_comments_yet: 'Noch keine Kommentare',

  // Client Inbox [Modal]
  no_messages_yet: 'Noch keine Nachrichten',

  // Item Editing [Modal]
  edit: 'Bearbeiten',
  upload: 'Hochladen',
  upload_new_file: 'Neue Datei hochladen',
  file_must_be: 'Die Datei muss 50 MB oder kleiner sein',
  choose_file: 'Datei auswählen',
  uploaded_files: 'Hochgeladene Dateien',
  delete_files: 'Dateien löschen',
  saving: 'Speichern',
  column_type_not_found: 'Spaltentyp nicht gefunden',
  no_value_found: 'Für diese Spalte wurde kein Wert gefunden.',
  column_type_not_supported: 'Dieser Spaltentyp wird noch nicht unterstützt.',

  uploading_file: 'Datei wird hochgeladen',
  deleting_file: 'Dateien werden gelöscht',
  new: 'Neu',

  choose_an_option: 'Wählen Sie eine Option aus und klicken Sie dann auf Speichern.',
  update_the_text: 'Aktualisieren Sie den obigen Text und klicken Sie dann auf Speichern.',
  update_the_number: 'Aktualisieren Sie die obige Zahl und klicken Sie dann auf Speichern.',
  utc_time_info: 'Geben Sie die Zeit in UTC ein. Die Anzeige passt sich nach dem Speichern an die Zeitzone des Portals an.',
  time: 'Zeit',

  // Item Search
  search_placeholder: 'Suche',
  search_in: ' in',
  search_button: 'Suchen',
  search_clear: 'Zurücksetzen',
  search_all_columns: 'Alle Spalten',
  search_no_columns: 'Keine durchsuchbaren Spalten',
  search_column_placeholder: 'Wählen wo gesucht werden soll',

  // Table Sorting
  sort_ascending: 'Aufsteigend sortieren',
  sort_descending: 'Absteigend sortieren',
  sort_reset: 'Sortierung zurücksetzen',

  // File Upload
  upload_file: 'Hochladen',
  process_file: 'Verarbeiten',
  retry_file_upload: 'Wiederholen',

  // Warnings + Errors
  could_not_load_section: 'Abschnitt konnte nicht geladen werden',
  section_setup_incomplete: 'Abschnittseinrichtung unvollständig',
  higher_error_rates: 'Die Fehlerquote ist derzeit höher als üblich, wir entschuldigen uns für die Unannehmlichkeiten.',
  check_status: 'Status überprüfen',
  item_actions_expired: 'Ihr Zugriff auf diesen Eintrag ist abgelaufen. Bitte laden Sie die Seite neu, um diese Aktionen zu verwenden.',
};

const langFr: typeof langEn = {
  // Common
  fetching_data: 'Récupération des données',
  reload_section: 'Recharger la section',
  automatic_data_fetching_disabled: 'La récupération automatique des données est désactivée, rechargez pour synchroniser.',
  warning_label: 'Avertissement:',
  error_label: 'Erreur:',
  no_board_defined: 'Aucune source de données définie.',
  no_text_defined: 'Aucune en-tête ou texte défini.',
  no_url_defined: "Aucune URL d'intégration définie.",
  section_type_missing: 'Le type de section est manquant.',

  // Login Page
  sign_in_to_your_account: 'Connectez-vous à votre compte',
  email: 'Email',
  password: 'Mot de passe',
  sign_in: 'Se connecter',
  sign_out: 'Se déconnecter',
  or: 'OU',

  // Portal Header
  activity: 'Activité',
  inbox: 'Messages',

  // Portal Footer
  copyright: 'Copyright © [YEAR] par [PORTAL_NAME]. Tous droits réservés.',

  // Table section
  download_file: 'Télécharger [FILE_NAME]',
  section_empty: 'Rien à afficher pour le moment.',
  section_no_column_visible: "Aucune colonne n'est définie comme visible pour le moment.",
  aggregate_label_sum: 'Somme',
  aggregate_label_avg: 'Moyenne',
  aggregate_label_min: 'Min',
  aggregate_label_max: 'Max',
  aggregate_label_count: 'Nombre',
  aggregate_label_median: 'Médiane',

  // Grid Section
  show_more: 'Afficher plus',

  // Detail View
  show_details: 'Voir les détails',
  no_details_available: 'Aucun détail disponible',

  // File Viewer [Modal]
  download: 'Télécharger',
  preview: 'Aperçu',
  no_preview_available: 'Aucun aperçu disponible pour',

  // Activity Log [Modal]
  activity_from: 'Activité de',
  no_recent_activity: 'Aucune activité récente',
  activity_older_than_30_days: 'Aucune activité dans les 30 derniers jours',

  // Account Settings [Modal]
  account_settings: 'Paramètres du compte',
  current_password: 'Mot de passe actuel',
  new_password: 'Nouveau mot de passe',
  confirm_password: 'Confirmer le mot de passe',
  password_must_have: 'Le mot de passe doit comporter au moins 8 caractères, y compris un chiffre et un symbole.',
  save: 'Enregistrer',
  the_account_password_was_successfully_updated:
    "Le mot de passe du compte a été mis à jour avec succès. Commencez à l'utiliser lors de votre prochaine connexion.",

  // Item Comments [Modal]
  comments: 'Commentaires',
  attachments_max_size: 'La taille maximale est de 50 Mo.',
  the_file_exceeds: 'La taille du fichier dépasse la limite de 50 Mo.',
  type_your_comment_here: 'Tapez votre commentaire ici...',
  type_your_reply_here: 'Tapez votre réponse ici...',
  //create_comment: 'Créer un commentaire',
  create_comment: 'Créer',
  comment_time_ago: '[NAME] · Il y a [DATE]',
  delete: 'Supprimer',
  replied: 'a répondu',
  cancel: 'Annuler',
  reply: 'Répondre',
  no_comments_yet: 'Pas de commentaires pour le moment',

  // Client Inbox [Modal]
  no_messages_yet: 'Pas de messages pour le moment',

  // Item Editing [Modal]
  edit: 'Modifier',
  upload: 'Télécharger',
  upload_new_file: 'Télécharger un nouveau fichier',
  file_must_be: 'Le fichier doit être de 50 Mo ou moins',
  choose_file: 'Choisir un fichier',
  uploaded_files: 'Fichiers téléchargés',
  delete_files: 'Supprimer des fichiers',
  saving: 'Enregistrement',
  column_type_not_found: 'Type de colonne non trouvé',
  no_value_found: 'Aucune valeur trouvée pour cette colonne.',
  column_type_not_supported: "Ce type de colonne n'est pas encore pris en charge.",

  uploading_file: 'Téléchargement du fichier',
  deleting_file: 'Suppression du fichier',
  new: 'Nouveau',

  choose_an_option: 'Choisissez une option ci-dessus, puis cliquez sur Enregistrer.',
  update_the_text: 'Mettez à jour le texte ci-dessus, puis cliquez sur Enregistrer.',
  update_the_number: 'Mettez à jour le nombre ci-dessus, puis cliquez sur Enregistrer.',
  utc_time_info: `Entrez l'heure en UTC. L'affichage s'ajuste au fuseau horaire du portail après l'enregistrement.`,
  time: 'Heure',

  // Item Search
  search_placeholder: 'Rechercher',
  search_in: ' dans',
  search_button: 'Rechercher',
  search_clear: 'Effacer',
  search_all_columns: 'Toutes les colonnes',
  search_no_columns: 'Aucune colonne de recherche',
  search_column_placeholder: 'Choisissez où chercher',

  // Table Sorting
  sort_ascending: 'Trier par ordre croissant',
  sort_descending: 'Trier par ordre décroissant',
  sort_reset: 'Réinitialiser le tri',

  // File Upload
  upload_file: 'Téléversement',
  process_file: 'Traitement',
  retry_file_upload: 'Réessayer',

  // Warnings + Errors
  could_not_load_section: 'Impossible de charger la section',
  section_setup_incomplete: 'Configuration de la section incomplète',
  higher_error_rates: 'Les taux d’erreur sont plus élevés que d’habitude en ce moment, nous nous excusons pour le désagrément.',
  check_status: 'Vérifier le statut',
  item_actions_expired: 'Votre accès à cet élément a expiré. Veuillez actualiser la page pour utiliser ces actions.',
};

const langEs: typeof langEn = {
  // Common
  fetching_data: 'Recuperando datos',
  reload_section: 'Recargar sección',
  automatic_data_fetching_disabled: 'La recuperación automática de datos está deshabilitada, recargue para sincronizar.',
  warning_label: 'Advertencia:',
  error_label: 'Error:',
  no_board_defined: 'No se ha definido ninguna fuente de datos.',
  no_text_defined: 'No se ha definido ninguna descripción o texto.',
  no_url_defined: 'No se ha definido ninguna URL de integración.',
  section_type_missing: 'Falta el tipo de sección.',

  // Login Page
  sign_in_to_your_account: 'Iniciar sesión en su cuenta',
  email: 'Correo electrónico',
  password: 'Contraseña',
  sign_in: 'Iniciar sesión',
  sign_out: 'Cerrar sesión',
  or: 'O',

  // Portal Header
  activity: 'Actividad',
  inbox: 'Mensajes',

  // Portal Footer
  copyright: 'Copyright © [YEAR] por [PORTAL_NAME]. Todos los derechos reservados.',

  // Table section
  download_file: 'Descargar [FILE_NAME]',
  section_empty: 'Nada que mostrar aquí en este momento.',
  section_no_column_visible: 'No hay columnas configuradas como visibles en este momento.',
  aggregate_label_sum: 'Suma',
  aggregate_label_avg: 'Promedio',
  aggregate_label_min: 'Mínimo',
  aggregate_label_max: 'Máximo',
  aggregate_label_count: 'Cuenta',
  aggregate_label_median: 'Mediana',

  // Grid Section
  show_more: 'Mostrar más',

  // Detail View
  show_details: 'Ver detalles',
  no_details_available: 'No hay detalles disponibles',

  // File Viewer [Modal]
  download: 'Descargar',
  preview: 'Vista previa',
  no_preview_available: 'No hay vista previa disponible para',

  // Activity Log [Modal]
  activity_from: 'Actividad de',
  no_recent_activity: 'No hay actividad reciente',
  activity_older_than_30_days: 'No hay actividad en los últimos 30 días',

  // Account Settings [Modal]
  account_settings: 'Configuración de la cuenta',
  current_password: 'Contraseña actual',
  new_password: 'Nueva contraseña',
  confirm_password: 'Confirmar contraseña',
  password_must_have: 'La contraseña debe tener al menos 8 caracteres, incluyendo un número y un símbolo.',
  save: 'Guardar',
  the_account_password_was_successfully_updated:
    'La contraseña de la cuenta se actualizó correctamente. Comience a usarla en su próximo inicio de sesión.',

  // Item Comments [Modal]
  comments: 'Comentarios',
  attachments_max_size: 'El tamaño máximo de archivo es de 50 MB.',
  the_file_exceeds: 'El tamaño del archivo excede el límite de 50 MB.',
  type_your_comment_here: 'Escriba su comentario aquí...',
  type_your_reply_here: 'Escriba su respuesta aquí...',
  //create_comment: 'Crear un comentario',
  create_comment: 'Crear',
  comment_time_ago: '[NAME] · Hace [DATE]',
  delete: 'Eliminar',
  replied: 'respondió',
  cancel: 'Cancelar',
  reply: 'Responder',
  no_comments_yet: 'No hay comentarios todavía',

  // Client Inbox [Modal]
  no_messages_yet: 'No hay mensajes todavía',

  // Item Editing [Modal]
  edit: 'Editar',
  upload: 'Subir',
  upload_new_file: 'Subir un nuevo archivo',
  file_must_be: 'El archivo debe ser de 50 MB o menos',
  choose_file: 'Elegir un archivo',
  uploaded_files: 'Archivos subidos',
  delete_files: 'Eliminar archivos',
  saving: 'Guardando',
  column_type_not_found: 'Tipo de columna no encontrado',
  no_value_found: 'No se encontró ningún valor para esta columna.',
  column_type_not_supported: 'Este tipo de columna aún no es compatible.',

  uploading_file: 'Subiendo archivo',
  deleting_file: 'Eliminando archivo',
  new: 'Nuevo',
  choose_an_option: 'Elija una opción de arriba y luego haga clic en guardar.',
  update_the_text: 'Actualice el texto de arriba y luego haga clic en guardar.',
  update_the_number: 'Actualice el número de arriba y luego haga clic en guardar.',
  utc_time_info: 'Ingrese la hora en UTC. La visualización se ajusta a la zona horaria del portal después de guardar.',
  time: 'Hora',

  // Item Search
  search_placeholder: 'Buscar',
  search_in: ' en',
  search_button: 'Buscar',
  search_clear: 'Borrar',
  search_all_columns: 'Todas las columnas',
  search_no_columns: 'No hay columnas para buscar',
  search_column_placeholder: 'Elija dónde buscar',

  // Table Sorting
  sort_ascending: 'Ordenar ascendente',
  sort_descending: 'Ordenar descendente',
  sort_reset: 'Restablecer orden',

  // File Upload
  upload_file: 'Subiendo',
  process_file: 'Procesando',
  retry_file_upload: 'Reintentar',

  // Warnings + Errors
  could_not_load_section: 'No se pudo cargar la sección',
  section_setup_incomplete: 'La configuración de la sección está incompleta',
  higher_error_rates: 'Las tasas de error son más altas de lo habitual en este momento, nos disculpamos por las molestias.',
  check_status: 'Verificar estado',
  item_actions_expired: 'Tu acceso a este elemento ha caducado. Actualiza la página para usar estas acciones.',
};

const langPt: typeof langEn = {
  // Common
  fetching_data: 'Recuperando dados',
  reload_section: 'Recarregar seção',
  automatic_data_fetching_disabled: 'A recuperação automática de dados está desabilitada, recarregue para sincronizar.',
  warning_label: 'Aviso:',
  error_label: 'Erro:',
  no_board_defined: 'Nenhuma fonte de dados definida.',
  no_text_defined: 'Nenhum título ou texto definido.',
  no_url_defined: 'Nenhuma URL de incorporação definida.',
  section_type_missing: 'Tipo de seção ausente.',

  // Login Page
  sign_in_to_your_account: 'Faça login na sua conta',
  email: 'Email',
  password: 'Senha',
  sign_in: 'Entrar',
  sign_out: 'Sair',
  or: 'OU',

  // Portal Header
  activity: 'Atividade',
  inbox: 'Mensagens',

  // Portal Footer
  copyright: 'Copyright © [YEAR] por [PORTAL_NAME]. Todos os direitos reservados.',

  // Table section
  download_file: 'Baixar [FILE_NAME]',
  section_empty: 'Nenhum resultado correspondente encontrado.',
  section_no_column_visible: 'Nenhuma coluna está visível no momento.',
  aggregate_label_sum: 'Soma',
  aggregate_label_avg: 'Média',
  aggregate_label_min: 'Mínimo',
  aggregate_label_max: 'Máximo',
  aggregate_label_count: 'Contagem',
  aggregate_label_median: 'Mediana',

  // Grid Section
  show_more: 'Mostrar mais',

  // Detail View
  show_details: 'Mostrar detalhes',
  no_details_available: 'Nenhum detalhe disponível',

  // File Viewer [Modal]
  download: 'Baixar',
  preview: 'Visualizar',
  no_preview_available: 'Nenhuma visualização disponível para',

  // Activity Log [Modal]
  activity_from: 'Atividade de',
  no_recent_activity: 'Nenhuma atividade recente',
  activity_older_than_30_days: 'Nenhuma atividade nos últimos 30 dias',

  // Account Settings [Modal]
  account_settings: 'Configurações da conta',
  current_password: 'Senha atual',
  new_password: 'Nova senha',
  confirm_password: 'Confirmar senha',
  password_must_have: 'A senha deve ter pelo menos 8 caracteres, incluindo um número e um símbolo.',
  save: 'Salvar',
  the_account_password_was_successfully_updated: 'A senha da conta foi atualizada com sucesso. Comece a usá-la no seu próximo login.',

  // Item Comments [Modal]
  comments: 'Comentários',
  attachments_max_size: 'O tamanho máximo do arquivo é de 50 MB.',
  the_file_exceeds: 'O tamanho do arquivo excede o limite de 50 MB.',
  type_your_comment_here: 'Digite seu comentário aqui...',
  type_your_reply_here: 'Digite sua resposta aqui...',
  //create_comment: 'Criar comentário',
  create_comment: 'Criar',
  comment_time_ago: '[NAME] · [DATE] atrás',
  delete: 'Excluir',
  replied: 'respondeu',
  cancel: 'Cancelar',
  reply: 'Responder',
  no_comments_yet: 'Nenhum comentário ainda',

  // Client Inbox [Modal]
  no_messages_yet: 'Nenhuma mensagem ainda',

  // Item Editing [Modal]
  edit: 'Editar',
  upload: 'Enviar',
  upload_new_file: 'Enviar novo arquivo',
  uploading_file: 'Enviando arquivo',
  new: 'Novo',
  file_must_be: 'O arquivo deve ser de 50 MB ou menos',
  choose_file: 'Escolher arquivo',
  uploaded_files: 'Arquivos enviados',
  delete_files: 'Excluir arquivos',
  deleting_file: 'Excluindo arquivos',
  saving: 'Salvando',
  column_type_not_found: 'Tipo de coluna não encontrado',
  no_value_found: 'Nenhum valor encontrado para esta coluna.',
  column_type_not_supported: 'Este tipo de coluna ainda não é suportado.',
  choose_an_option: 'Escolha uma opção acima e clique em salvar.',
  update_the_text: 'Atualize o texto acima e clique em salvar.',
  update_the_number: 'Atualize o número acima e clique em salvar.',
  utc_time_info: `Digite o horário em UTC. A exibição será ajustada para o fuso horário do portal após salvar.`,
  time: 'Hora',

  // Item Search
  search_placeholder: 'Pesquisar',
  search_in: ' em',
  search_button: 'Pesquisar',
  search_clear: 'Limpar',
  search_all_columns: 'Todas as colunas',
  search_no_columns: 'Nenhuma coluna para pesquisar',
  search_column_placeholder: 'Escolha onde pesquisar',

  // Table Sorting
  sort_ascending: 'Ordenar crescente',
  sort_descending: 'Ordenar decrescente',
  sort_reset: 'Redefinir ordenação',

  // File Upload
  upload_file: 'Enviando',
  process_file: 'Processando',
  retry_file_upload: 'Tentar novamente',

  // Warnings + Errors
  could_not_load_section: 'Não foi possível carregar a seção',
  section_setup_incomplete: 'Configuração da seção incompleta',
  higher_error_rates: 'As taxas de erro estão mais altas do que o normal no momento, pedimos desculpas pelo inconveniente.',
  check_status: 'Verificar status',
  item_actions_expired: 'Seu acesso a este item expirou. Atualize a página para usar estas ações.',
};

const langPl: typeof langEn = {
  // Common
  fetching_data: 'Pobieranie danych',
  reload_section: 'Przeładuj sekcję',
  automatic_data_fetching_disabled: 'Automatyczne pobieranie danych jest wyłączone, przeładuj, aby zsynchronizować.',
  warning_label: 'Ostrzeżenie:',
  error_label: 'Błąd:',
  no_board_defined: 'Nie zdefiniowano źródła danych.',
  no_text_defined: 'Nie zdefiniowano nagłówka ani tekstu.',
  no_url_defined: 'Nie zdefiniowano adresu URL do osadzenia.',
  section_type_missing: 'Brak typu sekcji.',

  // Login Page
  sign_in_to_your_account: 'Zaloguj się na swoje konto',
  email: 'Email',
  password: 'Hasło',
  sign_in: 'Zaloguj się',
  sign_out: 'Wyloguj się',
  or: 'LUB',

  // Portal Header
  activity: 'Aktywność',
  inbox: 'Wiadomości',

  // Portal Footer
  copyright: 'Copyright © [YEAR] [PORTAL_NAME]. Wszelkie prawa zastrzeżone.',

  // Table section
  download_file: 'Pobierz [FILE_NAME]',
  section_empty: 'Brak pasujących wyników.',
  section_no_column_visible: 'Brak kolumn ustawionych jako widoczne w tym momencie.',
  aggregate_label_sum: 'Suma',
  aggregate_label_avg: 'Średnia',
  aggregate_label_min: 'Min',
  aggregate_label_max: 'Maks',
  aggregate_label_count: 'Liczba',
  aggregate_label_median: 'Mediana',

  // Grid Section
  show_more: 'Pokaż więcej',

  // Detail View
  show_details: 'Pokaż szczegóły',
  no_details_available: 'Brak dostępnych szczegółów',

  // File Viewer [Modal]
  download: 'Pobierz',
  preview: 'Podgląd',
  no_preview_available: 'Brak podglądu dla',

  // Activity Log [Modal]
  activity_from: 'Aktywność od',
  no_recent_activity: 'Brak ostatniej aktywności',
  activity_older_than_30_days: 'Brak aktywności w ciągu ostatnich 30 dni',

  // Account Settings [Modal]
  account_settings: 'Ustawienia konta',
  current_password: 'Aktualne hasło',
  new_password: 'Nowe hasło',
  confirm_password: 'Potwierdź hasło',
  password_must_have: 'Hasło musi zawierać co najmniej 8 znaków, w tym jedną cyfrę i jeden symbol.',
  save: 'Zapisz',
  the_account_password_was_successfully_updated:
    'Hasło do konta zostało pomyślnie zaktualizowane. Zacznij z niego korzystać przy następnym logowaniu.',

  // Item Comments [Modal]
  comments: 'Komentarze',
  attachments_max_size: 'Maksymalny rozmiar pliku to 50 MB.',
  the_file_exceeds: 'Rozmiar pliku przekracza limit 50 MB.',
  type_your_comment_here: 'Wpisz swój komentarz tutaj...',
  type_your_reply_here: 'Wpisz swoją odpowiedź tutaj...',
  //create_comment: 'Utwórz komentarz',
  create_comment: 'Utwórz',
  comment_time_ago: '[NAME] · [DATE] temu',
  delete: 'Usuń',
  replied: 'odpowiedział',
  cancel: 'Anuluj',
  reply: 'Odpowiedz',
  no_comments_yet: 'Brak komentarzy',

  // Client Inbox [Modal]
  no_messages_yet: 'Brak wiadomości',

  // Item Editing [Modal]
  edit: 'Edytuj',
  upload: 'Prześlij',
  upload_new_file: 'Prześlij nowy plik',
  uploading_file: 'Przesyłanie pliku',
  new: 'Nowy',
  file_must_be: 'Plik musi mieć rozmiar 50 MB lub mniejszy',
  choose_file: 'Wybierz plik',
  uploaded_files: 'Przesłane pliki',
  delete_files: 'Usuń pliki',
  deleting_file: 'Usuwanie plików',
  saving: 'Zapisywanie',
  column_type_not_found: 'Nie znaleziono typu kolumny',
  no_value_found: 'Nie znaleziono wartości dla tej kolumny.',
  column_type_not_supported: 'Ten typ kolumny nie jest jeszcze obsługiwany.',
  choose_an_option: 'Wybierz opcję powyżej, a następnie kliknij zapisz.',
  update_the_text: 'Zaktualizuj powyższy tekst, a następnie kliknij zapisz.',
  update_the_number: 'Zaktualizuj powyższą liczbę, a następnie kliknij zapisz.',
  utc_time_info: 'Wprowadź czas w UTC. Wyświetlanie dostosuje się do strefy czasowej portalu po zapisaniu.',
  time: 'Czas',

  // Item Search
  search_placeholder: 'Szukaj',
  search_in: ' w',
  search_button: 'Szukaj',
  search_clear: 'Wyczyść',
  search_all_columns: 'Wszystkie kolumny',
  search_no_columns: 'Brak kolumn do wyszukiwania',
  search_column_placeholder: 'Wybierz gdzie szukać',

  // Table Sorting
  sort_ascending: 'Sortuj rosnąco',
  sort_descending: 'Sortuj malejąco',
  sort_reset: 'Zresetuj sortowanie',

  // File Upload
  upload_file: 'Przesyłanie',
  process_file: 'Przetwarzanie',
  retry_file_upload: 'Spróbuj ponownie',

  // Warnings + Errors
  could_not_load_section: 'Nie można załadować sekcji',
  section_setup_incomplete: 'Niekompletna konfiguracja sekcji',
  higher_error_rates: 'Obecnie wskaźniki błędów są wyższe niż zwykle, przepraszamy za niedogodności.',
  check_status: 'Sprawdź status',
  item_actions_expired: 'Twój dostęp do tego elementu wygasł. Odśwież stronę, aby użyć tych akcji.',
};

const langHe: typeof langEn = {
  // Common
  fetching_data: 'טוען נתונים',
  reload_section: 'טען מחדש את המקטע',
  automatic_data_fetching_disabled: 'טיעון אוטומטי של נתונים מושבת, טען מחדש כדי לסנכרן.',
  warning_label: 'אזהרה:',
  error_label: 'שגיאה:',
  no_board_defined: 'לא הוגדר מקור נתונים.',
  no_text_defined: 'לא הוגדרה כותרת או טקסט.',
  no_url_defined: 'לא הוגדרה כתובת URL להטמעה.',
  section_type_missing: 'סוג המקטע חסר.',

  // Login Page
  sign_in_to_your_account: 'התחבר לחשבון שלך',
  email: 'אימייל',
  password: 'סיסמה',
  sign_in: 'התחבר',
  sign_out: 'התנתק',
  or: 'או',

  // Portal Header
  activity: 'פעילות',
  inbox: 'הודעות',

  // Portal Footer
  copyright: 'זכויות יוצרים © [YEAR] מאת [PORTAL_NAME]. כל הזכויות שמורות.',

  // Table section
  download_file: 'הורד [FILE_NAME]',
  section_empty: 'לא נמצאו תוצאות תואמות.',
  section_no_column_visible: 'אין עמודות גלויות כרגע.',
  aggregate_label_sum: 'סכום',
  aggregate_label_avg: 'ממוצע',
  aggregate_label_min: 'מינימום',
  aggregate_label_max: 'מקסימום',
  aggregate_label_count: 'ספירה',
  aggregate_label_median: 'חציון',

  // Grid Section
  show_more: 'הצג עוד',

  // Detail View
  show_details: 'הצג פרטים',
  no_details_available: 'אין פרטים זמינים',

  // File Viewer [Modal]
  download: 'הורד',
  preview: 'תצוגה מקדימה',
  no_preview_available: 'אין תצוגה מקדימה עבור',

  // Activity Log [Modal]
  activity_from: 'פעילות מ-',
  no_recent_activity: 'אין פעילות אחרונה',
  activity_older_than_30_days: 'לא הייתה פעילות ב-30 הימים האחרונים.',

  // Account Settings [Modal]
  account_settings: 'הגדרות חשבון',
  current_password: 'סיסמה נוכחית',
  new_password: 'סיסמה חדשה',
  confirm_password: 'אישור סיסמה',
  password_must_have: 'הסיסמה חייבת להכיל לפחות 8 תווים, כולל מספר אחד וסימן אחד.',
  save: 'שמור',
  the_account_password_was_successfully_updated: 'סיסמת החשבון עודכנה בהצלחה. ניתן להשתמש בה בהתחברות הבאה.',

  // Item Comments [Modal]
  comments: 'תגובות',
  attachments_max_size: 'גודל הקובץ המרבי הוא 50MB.',
  the_file_exceeds: 'גודל הקובץ חורג ממגבלת 50MB.',
  type_your_comment_here: 'הקלד את התגובה שלך כאן...',
  type_your_reply_here: 'הקלד את התשובה שלך כאן...',
  create_comment: 'צור',
  comment_time_ago: '[NAME] · לפני [DATE]',
  delete: 'מחק',
  replied: 'השיב',
  cancel: 'ביטול',
  reply: 'השב',
  no_comments_yet: 'אין תגובות עדיין',

  // Client Inbox [Modal]
  no_messages_yet: 'אין הודעות עדיין',

  // Item Editing [Modal]
  edit: 'ערוך',
  upload: 'העלה',
  upload_new_file: 'העלה קובץ חדש',
  uploading_file: 'מעלה קובץ',
  new: 'חדש',
  file_must_be: 'הקובץ חייב להיות 50MB או פחות.',
  choose_file: 'בחר קובץ',
  uploaded_files: 'קבצים שהועלו',
  delete_files: 'מחק קבצים',
  deleting_file: 'מוחק קבצים',
  saving: 'שומר',
  column_type_not_found: 'סוג העמודה לא נמצא',
  no_value_found: 'לא נמצא ערך עבור עמודה זו.',
  column_type_not_supported: 'סוג עמודה זה עדיין אינו נתמך.',
  choose_an_option: 'בחר אפשרות למעלה ולאחר מכן לחץ על שמור.',
  update_the_text: 'עדכן את הטקסט למעלה ולאחר מכן לחץ על שמור.',
  update_the_number: 'עדכן את המספר למעלה ולאחר מכן לחץ על שמור.',
  utc_time_info: `הזן את השעה ב-UTC. לאחר השמירה, התצוגה תותאם לאזור הזמן של הפורטל.`,
  time: 'שעה',

  // Item Search
  search_placeholder: 'חיפוש',
  search_in: ' בתוך',
  search_button: 'חפש',
  search_clear: 'איפוס',
  search_all_columns: 'כל העמודות',
  search_no_columns: 'אין עמודות לחיפוש',
  search_column_placeholder: 'בחר היכן לחפש',

  // Table Sorting
  sort_ascending: 'מיין בסדר עולה',
  sort_descending: 'מיין בסדר יורד',
  sort_reset: 'אפס מיון',

  // File Upload
  upload_file: 'מעלה',
  process_file: 'מעבד',
  retry_file_upload: 'נסה שוב',

  // Warnings + Errors
  could_not_load_section: 'לא ניתן לטעון את המקטע',
  section_setup_incomplete: 'הגדרת המקטע לא הושלמה',
  higher_error_rates: 'שיעורי השגיאות גבוהים מהרגיל כרגע. אנו מתנצלים על אי הנוחות.',
  check_status: 'בדוק מצב',
  item_actions_expired: 'הגישה שלך לפריט זה פגה. יש לרענן את הדף כדי להשתמש בפעולות אלה.',
};

const langZh: typeof langEn = {
  // Common
  fetching_data: '正在获取数据',
  reload_section: '重新加载部分',
  automatic_data_fetching_disabled: '自动数据获取已禁用，请重新加载以同步。',
  warning_label: '警告：',
  error_label: '错误：',
  no_board_defined: '未定义数据源。',
  no_text_defined: '未定义标题或文本。',
  no_url_defined: '未定义嵌入 URL。',
  section_type_missing: '缺少节类型。',

  // Login Page
  sign_in_to_your_account: '登录您的账户',
  email: '电子邮件',
  password: '密码',
  sign_in: '登录',
  sign_out: '登出',
  or: '或',

  // Portal Header
  activity: '活动',
  inbox: '消息',

  // Portal Footer
  copyright: '版权所有 © [YEAR] [PORTAL_NAME]。 保留所有权利。',

  // Table section
  download_file: '下载 [FILE_NAME]',
  section_empty: '目前没有内容可显示。',
  section_no_column_visible: '目前没有列设置为可见。',
  aggregate_label_sum: '总和',
  aggregate_label_avg: '平均值',
  aggregate_label_min: '最小值',
  aggregate_label_max: '最大值',
  aggregate_label_count: '计数',
  aggregate_label_median: '中位数',

  // Grid Section
  show_more: '显示更多',

  // Detail View
  show_details: '查看详情',
  no_details_available: '暂无详情可用',

  // File Viewer [Modal]
  download: '下载',
  preview: '预览',
  no_preview_available: '无法预览',

  // Activity Log [Modal]
  activity_from: '来自',
  no_recent_activity: '没有最近的活动',
  activity_older_than_30_days: '过去 30 天没有活动',

  // Account Settings [Modal]
  account_settings: '账户设置',
  current_password: '当前密码',
  new_password: '新密码',
  confirm_password: '确认密码',
  password_must_have: '密码必须至少包含 8 个字符，包括一个数字和一个符号。',
  save: '保存',
  the_account_password_was_successfully_updated: '帐户密码已成功更新。请在下次登录时使用它。',

  // Item Comments [Modal]
  comments: '评论',
  attachments_max_size: '附件的最大文件大小为 50 MB。',
  the_file_exceeds: '文件大小超过 50 MB 限制。',
  type_your_comment_here: '在此输入您的评论...',
  type_your_reply_here: '在此输入您的回复...',
  //create_comment: '创建评论',
  create_comment: '创建',
  comment_time_ago: '[NAME] · [DATE] 前',
  delete: '删除',
  replied: '已回复',
  cancel: '取消',
  reply: '回复',
  no_comments_yet: '暂无评论',

  // Client Inbox [Modal]
  no_messages_yet: '暂无消息',

  // Item Editing [Modal]
  edit: '编辑',
  upload: '上传',
  upload_new_file: '上传新文件',
  uploading_file: '正在上传文件',
  new: '新建',
  file_must_be: '文件必须小于 50 MB',
  choose_file: '选择文件',
  uploaded_files: '已上传文件',
  delete_files: '删除文件',
  deleting_file: '正在删除文件',
  saving: '正在保存',
  column_type_not_found: '未找到列类型',
  no_value_found: '未找到此列的值。',
  column_type_not_supported: '此列类型尚不受支持。',
  choose_an_option: '从上面选择一个选项，然后单击保存。',
  update_the_text: '更新上面的文本，然后单击保存。',
  update_the_number: '更新上面的数字，然后单击保存。',
  utc_time_info: '请以 UTC 格式输入时间。保存后，显示将调整为门户的时区。',
  time: '时间',

  // Item Search
  search_placeholder: '搜索',
  search_in: ' ',
  search_button: '搜索',
  search_clear: '清除',
  search_all_columns: '所有列',
  search_no_columns: '没有可搜索的列',
  search_column_placeholder: '选择搜索位置',

  // Table Sorting
  sort_ascending: '升序排序',
  sort_descending: '降序排序',
  sort_reset: '重置排序',

  // File Upload
  upload_file: '上传中',
  process_file: '处理中',
  retry_file_upload: '重试',

  // Warnings + Errors
  could_not_load_section: '无法加载部分',
  section_setup_incomplete: '部分设置不完整',
  higher_error_rates: '目前错误率高于正常水平，我们对此造成的不便表示歉意。',
  check_status: '查看状态',
  item_actions_expired: '您对此项目的访问已过期。请刷新页面以使用这些操作。',
};

export const LANGS = {
  en: langEn,
  de: langDe,
  fr: langFr,
  es: langEs,
  pt: langPt,
  pl: langPl,
  he: langHe,
  zh: langZh,
};

export const DEFAULT_LANG = 'en';

export function getLangString(lang: keyof typeof LANGS | undefined, key: keyof typeof langEn, args?: Record<string, string>) {
  let langString = (lang && LANGS[lang]?.[key]) || LANGS[DEFAULT_LANG][key] || key;
  if (args) {
    Object.keys(args).forEach((argKey) => {
      const argValue = args[argKey];
      langString = langString.replace(`[${argKey}]`, argValue);
    });
  }
  return langString;
}

export function isRtl(langKey?: string) {
  return langKey === 'he';
}
